<template>

  <button aria-label="dodaj u korpu" data-tooltip="Dodaj u korpu" class="tooltip" v-if="this.type === 'shop'"
          @click="addToCart">
    <cart-icon></cart-icon>
  </button>

  <button v-else class="add" @click="addToCart">DODAJ U KORPU</button>

</template>

<script>
  export default {

    props: [
      'productCode',
      'type',
	    'product'
    ],

    methods: {
      addToCart() {

				// get last category.
	      var lastItem = this.product.categories ? this.product.categories.pop() : null;

	      dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
	      dataLayer.push({
		      event: "add_to_cart",
		      ecommerce: {
			      currency: "RSD",
			      value: this.product.price_small,
			      items: [
				      {
					      item_id: this.product.id,
					      item_name: this.product.title,
					      discount: this.product.discount,
					      index: 0,
					      item_brand: this.product.brandTitle,
					      item_category: lastItem ? lastItem.title : this.product.price_small > 15000 ? 'Satovi' : 'Nakit',
					      price: this.product.price_small,
					      quantity: 1
				      }
			      ]
		      }
	      });

        axios.post('/korpa', {productCode: this.productCode})
            .then(response => {
              //this.$toasted.global.toastSuccess({ message: response.data.message });

              // Update vuex store, cart items
              this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
              // Update vuex store, cart count
              this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
              // Update vuex store, cart count
              this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
              // Update vuex store, side cart to true
              this.$store.dispatch('Cart/changeSideCart', true);

            })
            .catch(error => {
              this.$toasted.global.toastError({message: error.response.data.message});
            })
      }
    }
  }
</script>